import { ContactsCompany, ContactsPosition, ContactsTaxId, ContactsFirstName, ContactsLastName, ContactsEmail, ContactsBirthdate, ContactsPhone, ContactsAddress, ContactsSubscribe, TextInput, TextArea, Dropdown, UrlInput, NumberInput, Checkbox, CheckboxGroup, RadioGroup, Header, RichText, SubmitButton, QuizMultiChoice, QuizShortText, QuizNumber, QuizSingleChoice, QuizLongText, FileUpload, QuizFileUpload, NestedForm, MultilineAddress, MlaCountry, MlaCity, MlaAddressLine, MlaAddressLine2, MlaPostalCode, MlaSubdivision, MlaStreetName, MlaStreetNumber, MlaApartment, VatId, DextCheckbox, DextCheckboxGroup, EcomAddress, DextDropdown, DextRadioGroup, DextTextArea, DextUrlInput, DextEmail, DextPhone, ContactsDateInput, ContactsNumberInput, ContactsTextInput, ContactsUrlInput, DateInput, DateTimeInput, TimeInput, ProductList } from '../fields';
import { DextNumberInput } from '../fields/dext-number-input';
import { DextTextInput } from '../fields/dext-text-input';
import { EcomAdditionalInfo } from '../fields/ecom-additional-info';
import { EcomCompanyName } from '../fields/ecom-company-name';
import { EcomEmail } from '../fields/ecom-email';
import { EcomFullName } from '../fields/ecom-full-name';
import { EcomHeader } from '../fields/ecom-header';
import { EcomPhone } from '../fields/ecom-phone';
import { FullName } from '../fields/full-name';
import { FullNameFirstName } from '../fields/full-name-first-name';
import { FullNameLastName } from '../fields/full-name-last-name';
import { FIELD_TYPES } from './field-types';
export const INPUT_ELEMENTS = {
  [FIELD_TYPES.ECOM_ADDITIONAL_INFO]: EcomAdditionalInfo,
  [FIELD_TYPES.RICH_TEXT]: RichText,
  [FIELD_TYPES.HEADER]: Header,
  [FIELD_TYPES.SUBMIT_BUTTON]: SubmitButton,
  [FIELD_TYPES.CHECKBOX]: Checkbox,
  [FIELD_TYPES.DATE_INPUT]: DateInput,
  [FIELD_TYPES.DATE_TIME_INPUT]: DateTimeInput,
  [FIELD_TYPES.TIME_INPUT]: TimeInput,
  [FIELD_TYPES.DROPDOWN]: Dropdown,
  [FIELD_TYPES.RADIO_GROUP]: RadioGroup,
  [FIELD_TYPES.CHECKBOX_GROUP]: CheckboxGroup,
  [FIELD_TYPES.NUMBER_INPUT]: NumberInput,
  [FIELD_TYPES.QUIZ_NUMBER]: QuizNumber,
  [FIELD_TYPES.QUIZ_SHORT_TEXT]: QuizShortText,
  [FIELD_TYPES.QUIZ_LONG_TEXT]: QuizLongText,
  [FIELD_TYPES.QUIZ_MULTI_CHOICE]: QuizMultiChoice,
  [FIELD_TYPES.QUIZ_SINGLE_CHOICE]: QuizSingleChoice,
  [FIELD_TYPES.QUIZ_FILE_UPLOAD]: QuizFileUpload,
  [FIELD_TYPES.FILE_UPLOAD]: FileUpload,
  [FIELD_TYPES.CONTACTS_EMAIL]: ContactsEmail,
  [FIELD_TYPES.CONTACTS_BIRTHDATE]: ContactsBirthdate,
  [FIELD_TYPES.CONTACTS_PHONE]: ContactsPhone,
  [FIELD_TYPES.URL_INPUT]: UrlInput,
  [FIELD_TYPES.CONTACTS_COMPANY]: ContactsCompany,
  [FIELD_TYPES.CONTACTS_POSITION]: ContactsPosition,
  [FIELD_TYPES.CONTACTS_TAX_ID]: ContactsTaxId,
  [FIELD_TYPES.CONTACTS_FIRST_NAME]: ContactsFirstName,
  [FIELD_TYPES.CONTACTS_LAST_NAME]: ContactsLastName,
  [FIELD_TYPES.CONTACTS_ADDRESS]: ContactsAddress,
  [FIELD_TYPES.CONTACTS_DATE_INPUT]: ContactsDateInput,
  [FIELD_TYPES.CONTACTS_NUMBER_INPUT]: ContactsNumberInput,
  [FIELD_TYPES.CONTACTS_TEXT_INPUT]: ContactsTextInput,
  [FIELD_TYPES.CONTACTS_URL_INPUT]: ContactsUrlInput,
  [FIELD_TYPES.TEXT_INPUT]: TextInput,
  [FIELD_TYPES.TEXT_AREA]: TextArea,
  [FIELD_TYPES.CONTACTS_SUBSCRIBE]: ContactsSubscribe,
  [FIELD_TYPES.MULTILINE_ADDRESS]: MultilineAddress,
  [FIELD_TYPES.NESTED_FORM]: NestedForm,
  [FIELD_TYPES.MLA_COUNTRY]: MlaCountry,
  [FIELD_TYPES.MLA_CITY]: MlaCity,
  [FIELD_TYPES.MLA_ADDRESS_LINE]: MlaAddressLine,
  [FIELD_TYPES.MLA_ADDRESS_LINE_2]: MlaAddressLine2,
  [FIELD_TYPES.MLA_POSTAL_CODE]: MlaPostalCode,
  [FIELD_TYPES.MLA_SUBDIVISION]: MlaSubdivision,
  [FIELD_TYPES.MLA_STREET_NAME]: MlaStreetName,
  [FIELD_TYPES.MLA_STREET_NUMBER]: MlaStreetNumber,
  [FIELD_TYPES.MLA_APARTMENT]: MlaApartment,
  [FIELD_TYPES.FULL_NAME]: FullName,
  [FIELD_TYPES.FULL_NAME_FIRST_NAME]: FullNameFirstName,
  [FIELD_TYPES.FULL_NAME_LAST_NAME]: FullNameLastName,
  [FIELD_TYPES.VAT_ID]: VatId,
  [FIELD_TYPES.DEXT_TEXT_INPUT]: DextTextInput,
  [FIELD_TYPES.DEXT_TEXT_AREA]: DextTextArea,
  [FIELD_TYPES.DEXT_DROPDOWN]: DextDropdown,
  [FIELD_TYPES.DEXT_RADIO_GROUP]: DextRadioGroup,
  [FIELD_TYPES.DEXT_URL_INPUT]: DextUrlInput,
  [FIELD_TYPES.DEXT_EMAIL]: DextEmail,
  [FIELD_TYPES.DEXT_PHONE]: DextPhone,
  [FIELD_TYPES.DEXT_NUMBER_INPUT]: DextNumberInput,
  [FIELD_TYPES.DEXT_CHECKBOX]: DextCheckbox,
  [FIELD_TYPES.DEXT_CHECKBOX_GROUP]: DextCheckboxGroup,
  [FIELD_TYPES.ECOM_ADDRESS]: EcomAddress,
  [FIELD_TYPES.ECOM_FULL_NAME]: EcomFullName,
  [FIELD_TYPES.ECOM_PHONE]: EcomPhone,
  [FIELD_TYPES.ECOM_COMPANY_NAME]: EcomCompanyName,
  [FIELD_TYPES.ECOM_EMAIL]: EcomEmail,
  [FIELD_TYPES.ECOM_CONTACT_DETAILS]: EcomHeader,
  [FIELD_TYPES.ECOM_SHIPPING_DETAILS]: EcomHeader,
  [FIELD_TYPES.PRODUCT_LIST]: ProductList
};
//# sourceMappingURL=components.js.map